import _ from 'lodash';

import { selectInvoiceStatus, selectInvoiceList } from '../invoices';

export const selectInvoiceMetrics = (store) => {
  const invoices = selectInvoiceList(store);
  const clients = [];
  let invoicesToProcess = 0;
  let overdueTotal = 0;
  let outstandingTotal = 0;
  let draftTotal = 0;

  invoices.forEach(invoice => {
    invoice.clientId && clients.push(invoice.clientId);

    if (invoice.id) {
      const status = selectInvoiceStatus(store, invoice);
      const grandTotal = Number(invoice.grandTotal.toFixed(2));
      invoicesToProcess++;

      switch (status.name.toLowerCase()) {
        case "overdue":
          overdueTotal += grandTotal;
          break;
        case "outstanding":
          outstandingTotal += grandTotal;
          break;
        case "draft":
          draftTotal += grandTotal;
          break;
        default:
      }
    }
  });

  return ([
    {
      type: "horizontal",
      label: "Invoices to process",
      display: invoicesToProcess,
    },
    {
      type: "horizontal",
      label: "Clients to process",
      display: _.uniq(clients).length,
    },
    {
      type: "vertical",
      label: "overdue",
      display: `$${overdueTotal.toFixed(2)}`,
    },
    {
      type: "vertical",
      label: "outstanding",
      display: `$${outstandingTotal}`,
    },
    {
      type: "vertical",
      label: "in draft",
      display: `$${draftTotal}`,
    }
  ]);
}



// WEBPACK FOOTER //
// ./src/store/selectors/metrics/invoices.js